<template>
    <div class="delete-account">
      <Header :loginHeader="true" />
  
      <section id="delete-account">
        <div class="container text-center">
          <div class="login-wrapper">
            <h3>iSale Web</h3>
            <p>Account Deletion Request</p>
            <div class="form">
              <div class="form-group">
                <input 
                  type="text" 
                  placeholder="Enter your PIN to confirm" 
                  v-model="pin" 
                  class="form-control"
                >
              </div>
              <div class="form-group">
                <input 
                  type="text" 
                  placeholder="Enter your username to confirm" 
                  v-model="username" 
                  class="form-control"
                >
              </div>
              <div class="form-group">
                <label class="checkbox-container text-left">
                  <input 
                    type="checkbox" 
                    v-model="confirmationChecked"
                  >
                  I understand this action cannot be undone
                </label>
              </div>
              <div class="form-group">
                <input 
                  type="button" 
                  value="Request Account Deletion" 
                  @click="submitDeletionRequest" 
                  class="btn-style full"
                  :disabled="!isFormValid"
                >
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import Header from '../../components/Header';
  import Swal from 'sweetalert2'
  
  export default {
    name: 'DeleteAccount',
    components: {
      Header,
    },
    data: () => ({
      pin: "",
      username: "",
      confirmationChecked: false,
    }),
    computed: {
      isFormValid() {
        return this.pin && 
               this.username && 
               this.confirmationChecked;
      }
    },
    methods: {
      async submitDeletionRequest() {
        if (!this.isFormValid) {
          Swal.fire({
            icon: 'error',
            title: 'Validation Error',
            text: 'Please fill all fields and confirm your understanding'
          });
          return;
        }
  
        try {
          const token = localStorage.getItem('access_token');
          if (!token) {
            throw new Error('Not authenticated');
          }
  
          const requestOptions = {
            method: "POST",
            headers: { 
              "Content-Type": "application/json",
              "Authorization": `Bearer ${JSON.parse(token)}`
            },
            body: JSON.stringify({ 
              pin: this.pin,
              username: this.username,
            })
          };
  
          const res = await fetch(process.env.VUE_APP_URL + '/auth/deactivate', requestOptions);
          const data = await res.json();
  
          if (data.status === true) {
            await Swal.fire({
              icon: 'success',
              title: 'Request Submitted',
              text: 'Your account deletion request has been received. It will be processed within 30 days.',
              confirmButtonText: 'OK'
            });
            
            // Clear local storage and cookies
            localStorage.clear();
            document.cookie.split(";").forEach(c => {
              document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            
            // Redirect to login
            this.$router.push("/login");
          } else {
            throw new Error(data.message || 'Failed to process request');
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Request Failed',
            text: error.message || 'Failed to process deletion request'
          });
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .checkbox-container {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;
  }
  
  .checkbox-container input[type="checkbox"] {
    width: auto;
    margin-right: 8px;
  }
  
  .text-left {
    text-align: left;
  }
  
  /* Inherit other styles from your login page */
  </style>